export default {
  name: 'GenericFieldsInfo',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
    inputFormType: {
      type: String,
      default: '',
    },
    inputFormTypes: {
      type: Array,
      default: () => [],
    },
    ports: {
      type: Array,
      default: () => [],
    },
    enums: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    apiVersion: 1,
    inputTypes: [],
    searchPorts: {},
  }),
  computed: {},
  methods: {
    loadGenericInputField() {
      const inputFormType = this.inputFormTypes.find(a => a.type === this.inputFormType);
      if (inputFormType != null) {
        this.inputTypes = inputFormType.fields;

        if (this.inputForm != null) {
          this.inputTypes.forEach((inputType) => {
            this.inputForm.properties.forEach((property) => {
              if (property.name === inputType.key) {
                // eslint-disable-next-line
                inputType.model = property.value;
              }
            });
          });
        }
      }
    },
    onInputFormSaved() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            const filledInInputTypes = this.inputTypes.filter(inputType => typeof inputType.model !== 'undefined');

            const postObjectInputTypes = filledInInputTypes.map(inputType => (
              {
                name: inputType.key,
                value: inputType.model,
                dataType: inputType.dataType,
              }
            ));

            this.$eventHub.$emit('fetch-generic-fields-info', postObjectInputTypes);
          } else {
            this.$eventHub.$emit('fetch-generic-fields-info', null);
          }
        })
        .catch(() => {
          console.log('something went wrong in file GenericFieldsInfo.controller.js method onInputFormSaved');
        });
    },
    getEnumItems(key) {
      if (this.enums != null) {
        const inputFormType = this.enums.find(e => e.name === key);
        if (inputFormType != null) {
          return inputFormType.values;
        }
      }

      return [];
    },
  },
  watch: {
    inputFormType() {
      this.loadGenericInputField();
    },
    inputFormTypes() {
      this.loadGenericInputField();
    },
    inputForm() {
      if (this.inputForm != null) {
        this.inputTypes.forEach((inputType) => {
          this.inputForm.properties.forEach((property) => {
            if (property.name === inputType.key) {
              // eslint-disable-next-line
              inputType.model = property.value;
            }
          });
        });
      }
    },
  },
  created() {
    this.loadGenericInputField();
    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);
  },
};
